module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-sm-12 header"
  }, [_c('router-link', {
    staticClass: "material-icons back-link",
    attrs: {
      "to": '/meal-plans/' + _vm.$route.params.id
    }
  }, [_vm._v("chevron_left")]), _vm._v(" "), _c('h1', [_vm._v("Add Meals")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.recipes), function(recipe) {
    return _c('li', {
      staticClass: "list-item",
      on: {
        "click": function($event) {
          _vm.addMeal(recipe)
        }
      }
    }, [_vm._v(_vm._s(recipe.title))])
  })), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-button mdl-button--raised",
    attrs: {
      "tag": "button",
      "to": '/meal-plans/' + _vm.$route.params.id
    }
  }, [_vm._v("Done")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b6c9e28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewMeal.vue
// module id = 139
// module chunks = 0